/** Will generate a timeout for a toast */
export const generateToastTimeout = (timeout, defaultTimeout) => {
    if (typeof timeout === "undefined") {
        return defaultTimeout;
    }
    else if (typeof timeout === "number") {
        return timeout;
    }
    else if (typeof timeout === "boolean" && timeout) {
        return defaultTimeout;
    }
    return undefined;
};
